import React from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../../ui/dropdown-menu';
import { Badge } from '../../ui/badge';
import { cn } from '../../../lib/utils';
import { DIFFICULTIES } from '../../../lib/constants';

export function DifficultyDropdown({ 
  difficulty, 
  onDifficultySelect, 
  isLandscape = false,
  variant = 'mobile'
}) {
  const diffConfig = DIFFICULTIES[difficulty];
  const isMobile = variant === 'mobile';
  
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Badge 
          variant="outline" 
          className={cn(
            "font-heading cursor-pointer hover:opacity-80 transition-opacity",
            isMobile ? (
              isLandscape ? "text-[10px] px-1.5 py-0" : "text-xs px-2 py-0.5"
            ) : "text-sm px-3 py-1",
            difficulty === 'easy' && "bg-success/10 text-success border-success/30",
            difficulty === 'normal' && "bg-primary/10 text-primary border-primary/30",
            difficulty === 'hard' && "bg-destructive/10 text-destructive border-destructive/30"
          )}
        >
          {diffConfig.name}
        </Badge>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="center" className="min-w-[140px]">
        {Object.entries(DIFFICULTIES).map(([key, config]) => (
          <DropdownMenuItem
            key={key}
            onClick={() => onDifficultySelect(key)}
            className={cn(
              "cursor-pointer flex items-center justify-between",
              difficulty === key && "bg-accent"
            )}
          >
            <span>{config.name}</span>
            <span className={cn(
              "text-xs ml-2",
              key === 'easy' && "text-success",
              key === 'normal' && "text-primary",
              key === 'hard' && "text-destructive"
            )}>
              x{config.multiplier}
            </span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
